<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>城市：</label>
                <el-input v-model="search_Obj.f_city" clearable @keyup.enter.native="doSearch" style="width: 140px"></el-input>
            </div>
            <div class="searchGroup">
                <label>车型：</label>
                <el-select v-model="search_Obj.f_model" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('model_type')" :key="'model_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>版本：</label>
                <el-select v-model="search_Obj.f_banben" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('model_banben')" :key="'model_banben'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>RN：</label>
                <el-input v-model="search_Obj.f_rn1" clearable @keyup.enter.native="doSearch" style="width: 120px"></el-input>
            </div>
            <div class="searchGroup">
                <label>号段：</label>
                <el-input v-model="search_Obj.rn2" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
            </div>
            <div class="searchGroup">
                <label>交付时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="searchBox">
            <div style="font-size: 14px;color: #909399;margin-right: 100px">预计提车周期：{{dayCount}}天</div>
            <div style="font-size: 14px;color: #909399;">预计提车时间：{{deliveryDate}}</div>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="city" label="城市" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="order_time" label="下单时间" sortable="custom" width="110">
                    <template slot-scope="scope">
                        <span>{{ formatDate1(scope.row.order_time, "yyyy-mm-dd") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="deliver_time" label="交付时间" sortable="custom" width="110">
                    <template slot-scope="scope">
                        <span>{{ formatDate1(scope.row.deliver_time, "yyyy-mm-dd") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rn2" label="号段" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="rn1" label="RN" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="model" label="型号" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="banben" label="版本" sortable="custom"></el-table-column>
                <el-table-column prop="batch" label="批次" sortable="custom" width="190"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看交付进度"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { exportDelivery } from '@/api/delivery'

export default {
    name: 'deliveryList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '交付进度',
            menu_id: 3100,
            list_url: "/api/admin/delivery/list",
            search_Obj: {
                f_batch: '',
                f_city: '',
                f_model: '',
                f_banben: '',
                f_rn1: '',
                rn2: '',
                f_deliver_time_s_date: '',
                f_deliver_time_e_date: ''
            },
            sortData: {
                prop: 'rn2',
                order: 'descending'
            },
            del_Obj:{
                url:'/api/admin/delivery/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['model_type', 'model_banben'],
            dayCount: '',
            deliveryDate: '',
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_deliver_time_s_date = val[0]
                this.search_Obj.f_deliver_time_e_date = val[1]
            }else{
                this.search_Obj.f_deliver_time_s_date = ''
                this.search_Obj.f_deliver_time_e_date = ''
            }
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.pageInfo.resultList;
                    this.total = res.data.pageInfo.totalRecords;
                    this.dayCount = res.data.dayCount;
                    this.deliveryDate = res.data.deliveryDate;
                }
            })
        },
        export(){
            exportDelivery(this.search_Obj.f_city, this.search_Obj.f_model, this.search_Obj.f_banben, this.search_Obj.rn2, this.search_Obj.f_deliver_time_s_date, this.search_Obj.f_deliver_time_e_date).then(res=>{
                if(res.code ==1){
                    window.open(res.data)
                }else if(res.code ==990){
                    this.$msg("无数据可导出")
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>